import Layout from '@layout/Index'

export const exception = [
  {
    path: '/exception',
    component: Layout,
    children: [
      {
        path: '404',
        component: () => import(/* webpackChunkName: "NotFound" */ '@core/pages/exception/NotFound'),
        name: 'NotFound',
        meta: {
          title: 'NotFound',
        },
      },
      {
        path: '403',
        component: () => import(/* webpackChunkName: "Forbidden" */ '@core/pages/exception/Forbidden'),
        name: 'Forbidden',
        meta: {
          title: 'Forbidden',
        },
      },
      {
        path: '424',
        component: () => import(/* webpackChunkName: "FailedDependency" */ '@core/pages/exception/FailedDependency'),
        name: 'FailedDependency',
        meta: {
          title: 'FailedDependency',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/exception/exception.route.js